module.exports = __webpack_public_path__ + "img/user-17.f3194714.svg";